import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { type ServiceType } from '../types';
import type Beverage from './beverage';
import type Supply from './supply';

@JsonApiResource({
  type: 'meal-category',
})
export default class MealCategory extends BaseEntity {
  name: string = '';
  abbreviation: string = '';
  description: string = '';
  @JsonApiProperty({ resolver: Number }) minQuantityAllowed: number = 1;
  hasDiabeticType: boolean = true;
  isGeneric: boolean = false;
  availableWeekDays: string = '1111111';
  hasSupplies: boolean = false;
  diets: string = '';
  preferences: string = '';
  @JsonApiRelationship('supply') supplies = new Array<Supply>();
  @JsonApiRelationship('beverage') beverages = new Array<Beverage>();
  allowC1OrC2: boolean = false;
  defaultServiceType: ServiceType = 'C1';
  isPrepackable: boolean = false;
  beverageFactor: number = 1;
  isCompleteMeal: boolean = false;
  @JsonApiProperty({ resolver: Number })
  units: number = 1;

  @JsonApiProperty({ resolver: Number }) public sortOrder = 127;
  isTestable: boolean = false;

  constructor(
    id?: MealCategory['id'],
    name: MealCategory['name'] = '',
    public defaultServeType: 'BULK' | 'INDIVIDUAL' | 'TRAY' = 'BULK',
    beverageFactor: MealCategory['beverageFactor'] = 1,
    sortOrder = 127
  ) {
    super();
    this.id = id;
    this.name = name;
    this.beverageFactor = beverageFactor;
    this.sortOrder = sortOrder;
  }
}

export interface MealCategoryWithoutRelationships
  extends Omit<MealCategory, 'supplies' | 'beverages'> {}

export const toMealCategoryWithoutRelationships = (
  mealCategory: MealCategory
): MealCategoryWithoutRelationships => {
  return {
    name: mealCategory?.name,
    abbreviation: mealCategory?.abbreviation,
    description: mealCategory?.description,
    minQuantityAllowed: mealCategory?.minQuantityAllowed,
    hasDiabeticType: mealCategory?.hasDiabeticType,
    isGeneric: mealCategory?.isGeneric,
    availableWeekDays: mealCategory?.availableWeekDays,
    hasSupplies: mealCategory?.hasSupplies,
    diets: mealCategory?.diets,
    preferences: mealCategory?.preferences,
    allowC1OrC2: mealCategory?.allowC1OrC2,
    defaultServiceType: mealCategory?.defaultServiceType,
    defaultServeType: mealCategory?.defaultServeType,
    sortOrder: mealCategory?.sortOrder,
    isPrepackable: mealCategory?.isPrepackable,
    beverageFactor: mealCategory?.beverageFactor,
    isCompleteMeal: mealCategory?.isCompleteMeal,
    units: mealCategory?.units,
    isTestable: mealCategory?.isTestable,
  };
};
